module.exports = __webpack_public_path__ + "static/media/cx.b2a59c5c.svg";